<template>
  <div
    class="text-center"
    :class="isDark ? 'white--text' : ''"
  >
    <div class="text-body-2 font-weight-light">
      {{ label }}
    </div>

    <div v-if="value">
      <span :class="[isPrincipal ? 'primary--text' : '', isSecondaire ? 'font-italic' : '', customClass]">{{ value | roundNumber(precision) }}</span>
      <span class="text-body-1 font-weight-light"> {{ unit }}</span>
    </div>
    <BaseTooltipNoData
      v-else
      :message="message"
      :is-dark="isDark"
    />
  </div>
</template>

<script>
import BaseTooltipNoData from '../common/base-tooltip-no-data.vue'
export default {
  name: 'BaseData',
  components: { BaseTooltipNoData },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String, Boolean],
      default: null
    },
    unit: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    precision: {
      type: Number,
      default: 0
    },
    isPrincipal: {
      type: Boolean,
      default: false
    },
    isSecondaire: {
      type: Boolean,
      default: false
    },
    isDark: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
</style>
